import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { MessageService } from '../../services/message.service';
import { NaviService } from '../../services/navi.service';
import { GroupService } from '../../services/group.service';

import { BasicError } from '../../models/error/error';
import { User } from '../../models/user';
import { Thread } from '../../models/thread';
import { Study } from '../../models/study';
declare var $: any;

@Component({
  selector: 'app-patient-messages-new',
  templateUrl: './patient-messages-new.component.html',
  styleUrls: ['./patient-messages-new.component.css']
})
export class PatientMessagesNewComponent implements OnInit {
  public participants: Array<User> = [];
  public allusers: Array<User> = [];
  public allstudies: Array<Study> = [];
  public allstudiesFinished = false;
  public isEmptyUsers = false;
  public lastUpdateCountAllUsers = 0;
  public timeoutAllUsers = null;
  public subject: String = null;
  public message: String = null;
  public buttonValue: String = 'Senden';
  public buttonClass: String = '';
  public buttonRedirectClass: String = '';
  public buttonRedirectText: String = 'Weiterleitung abbrechen';
  public buttonRedirectShow = false;
  public isErrorSubject = false;
  public isErrorMessage = false;
  public onSend = false;
  public thread = null;
  public redirectTimer = null;

  constructor(private userService: UserService, private messageService: MessageService, private naviService: NaviService,
    private groupService: GroupService) {
    this.allstudies = [];
    this.groupService.getMyGroups().subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not get all hcps of user');
      } else {
        this.allstudies = this.allstudies.concat(json);
      }
      this.allstudiesFinished = true;
    });
  }

  ngOnInit() {

  }

  /*
   * This function gets all Users.
   */
  public getAllUsers() {
    if (!this.allstudiesFinished) {
      return;
    }

    if (this.allusers.length !== 0) {
      return;
    }

    $('#datatableAllUsers').dataTable().fnDestroy();
    this.lastUpdateCountAllUsers = 0;
    this.allusers = [];
    this.groupService.getCollaboratorsOfStudies(this.allstudies).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading all users');
      } else if (data instanceof Array) {
        const tmp = this.allusers.concat(data);
        this.allusers = [];

        $('#datatableAllUsers').dataTable().fnDestroy();

        this.allusers = tmp;

        if (this.allusers.length !== 0) {
          this.isEmptyUsers = false;
        }
      }
    });

    if (this.allusers.length === 0) {
      this.isEmptyUsers = true;
    }
  }


  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllUsers() {
    if (this.lastUpdateCountAllUsers !== this.allusers.length) {
      this.lastUpdateCountAllUsers = this.allusers.length;

      if (this.timeoutAllUsers !== null) {
        clearTimeout(this.timeoutAllUsers);
      }

      this.timeoutAllUsers = setTimeout(function () {
        $('#datatableAllUsers').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }

  /**
   * adding a user to the participants
   * @param user User to add
   */
  public addParticipant(user: User) {
    const index = this.participants.indexOf(user, 0);
    if (index === -1) {
      this.participants.push(user);
    }
  }

  /**
   * Removing participant from list
   * @param user User to be removed
   */
  public removeParticipant(user: User) {
    const index = this.participants.indexOf(user, 0);
    if (index > -1) {
      this.participants.splice(index, 1);
    }
  }

  public sendMessage() {
    let isOk = true;
    this.isErrorSubject = false;
    this.isErrorMessage = false;

    if (this.subject === null || this.subject.length === 0) {
      this.isErrorSubject = true;
      isOk = false;
    }

    if (this.message === null || this.message.length === 0) {
      this.isErrorMessage = true;
      isOk = false;
    }

    if (!isOk) {
      return;
    }

    if (this.onSend) {
      return;
    }

    this.onSend = true;

    this.buttonClass = 'sendingButton';
    this.buttonValue = 'Wird gesendet...';

    // Create thread
    const thread = new Thread(null, this.subject);
    this.messageService.createNewThread(thread).subscribe(res => {
      if (res instanceof BasicError) {
        console.log('Failed to create Thread.');
        console.log(res);
        this.buttonClass = 'btn-danger';
        this.buttonValue = 'Senden fehlgeschlagen';
        this.onSend = false;
        return;
      }

      // Thread was created
      if (res instanceof Thread && res.getId() !== null) {
        this.thread = res;
        this.messageService.sendMessage(thread, this.message).subscribe(msg => {
          if (msg instanceof BasicError) {
            console.log('Failed to send Message');
            console.log(msg);
            this.buttonClass = 'btn-warning';
            this.buttonValue = 'Nachricht konnte nicht gesendet werden';
            this.onSend = false;
            return;
          }

          if (this.participants.length > 0) {
            this.messageService.addParticipants(thread, this.participants).subscribe(usr => {
              if (usr instanceof BasicError) {
                console.log('Failed to add participants');
                console.log(usr);
                this.buttonClass = 'btn-warning';
                this.buttonValue = 'Teilnehmer konnten nicht hinzugefügt werden';
                return;
              }

              this.buttonClass = 'sendedButton';
              this.buttonValue = 'Versendet';
              this.buttonRedirectShow = true;
              const self = this;
              setTimeout(function () {
                self.buttonRedirectClass = 'redirectAbort';
              }, 100);
              this.redirectTimer = setTimeout(function () { self.redirect(self.thread, self); }, 2000);
            });
          } else {
            this.buttonClass = 'sendedButton';
            this.buttonValue = 'Versendet';
            this.buttonRedirectShow = true;
            const self = this;
            setTimeout(function () {
              self.buttonRedirectClass = 'redirectAbort';
            }, 100);
            this.redirectTimer = setTimeout(function () { self.redirect(self.thread, self); }, 2000);
          }
        });
      } else {
        // Thread was created but failed to get Id
        console.log('Failed to get Id of thread');
        this.buttonClass = 'btn-warning';
        this.buttonValue = 'Thread erstellt, Nachricht fehlgeschlagen';
        this.onSend = false;
      }
    });
  }

  /**
   * This function redirects to the corresponding message that was created
   */
  public redirect(thread, self) {
    let url = '/messages/';
    url += thread.getId();
    self.naviService.navigateToUrl(url, 'hcpmessages');
  }

  /**
   * This function aborts the redirection to the message
   */
  public abortRedirect() {
    if (this.redirectTimer !== null) {
      clearTimeout(this.redirectTimer);
      this.buttonRedirectClass = 'redirect';
      this.buttonRedirectText = 'Zur Nachricht';
    }
  }

  /**
   * Decide if a redirection is necessary or the redirection will canceled
   */
  public redirectButtonTrigger() {
    if (this.redirectTimer !== null) {
      this.abortRedirect();
    } else {
      this.redirect(this.thread, this);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/patient-messages-new/patient-messages-new.component.ts